import { useEffect, useState, useCallback } from "react";
import { useDeviceListLive } from "@/hooks/useDeviceLive";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import WorldMap from "@/components/map/WorldMap";
import DeviceList from "@/components/devices/DeviceList";
import { useRegion } from "@/context/RegionContext";

export default function Overview() {
  const nav = useNavigate();
  const { active, byCode } = useRegion();
  const [allDevices, setDevices] = useState([]);
  const devices = active === "ALL" ? allDevices : allDevices.filter((d) => d.region_code === active);
  const [focus, setFocus] = useState(null);

  const load = useCallback(() => api.get("/devices").then((r) => setDevices(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useDeviceListLive(setDevices);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  const online = devices.filter((d) => d.status === "active").length;
  const liveKw = devices.reduce((s, d) => s + (d.status === "active" && d.live ? d.live.power_w : 0), 0) / 1000;

  return (
    <div className="h-full relative" data-testid="overview-page">
      <WorldMap devices={devices} focus={focus} />

      <div className="absolute top-5 left-5 z-[500] hidden lg:grid grid-cols-2 gap-px bg-kl-line border border-kl-line w-[300px] animate-rise" data-testid="overview-stats">
        {[["Nodes", devices.length, ""], ["Online", online, "text-kl-active"], ["Offline", devices.length - online, "text-kl-inactive"], ["Live load", `${liveKw.toFixed(2)} kW`, "text-kl-green"]].map(([l, v, c]) => (
          <div key={l} className="bg-kl-black p-4">
            <div className="kl-label-dark">{l}</div>
            <div className={`font-mono text-2xl mt-1 ${c}`} data-testid={`stat-${l.toLowerCase().replace(" ", "-")}`}>{v}</div>
          </div>
        ))}
        <div className="bg-kl-black col-span-2 px-4 py-2 flex items-center gap-2 border-t border-kl-line">
          <span className="w-1.5 h-1.5 bg-kl-green animate-pulse" />
          <span className="kl-label-dark" data-testid="overview-region-label">{active === "ALL" ? "Global monitoring network" : `${byCode[active]?.name || active} network · ${byCode[active]?.currency || ""}`}</span>
        </div>
      </div>

      <div className="absolute top-5 right-5 bottom-5 z-[500] w-[min(400px,calc(100%-40px))] animate-rise" style={{ animationDelay: "80ms" }}>
        <DeviceList devices={devices} onLink={() => nav("/register-device")} onFocus={setFocus} />
      </div>
    </div>
  );
}
